import React, { useState } from "react";
import Select from "react-select";

const style = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000811",
  }),
};

const CreditLimitApproval = () => {
  const [selectedCreditDays, setSelectedCreditDays] = useState(null);
  const [isRequestSubmitted, setIsRequestSubmitted] = useState(false);
  const [isAdditionalRequestShown, setIsAdditionalRequestShown] =
    useState(false);
  const dropdownOptions = [
    { value: "1", label: "Net 7 days" },
    { value: "2", label: "Net 15 days" },
  ];

  const handleRequest = () => {
    setIsRequestSubmitted(true);
  };

  const handleShowAdditionalRequest = () => {
    setIsAdditionalRequestShown(true);
  };

  const handleCancel = () => {
    setIsAdditionalRequestShown(false);
    setIsRequestSubmitted(false);
  };

  const handleCreditDaysChange = (selectedOption) => {
    setSelectedCreditDays(selectedOption);
  };

  const handleRequestMore = () => {
    setIsAdditionalRequestShown(true);
    setIsRequestSubmitted(true);
  };

  return (
    <>
      <div className="card d-none">
        <div class="card-header">
          <h2>Credit Limit Approval</h2>
        </div>
        <div className="card-body">
          <div className="row credit-limit-approval-row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
              <div className="row">
                {!isRequestSubmitted && (
                  <>
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="text-right">
                        <button type="button" className="btn credit-limit-btn">
                          <i
                            class="fas fa-plus-square"
                            onClick={handleRequestMore}
                          ></i>{" "}
                          Request More Credit Limit
                        </button>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-4 col-xs-12 mb-2">
                      <div>
                        <label>Credit Amount</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter"
                        ></input>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-4 col-xs-12 mb-2">
                      <div>
                        <label>Credit days</label>
                        <Select
                          name="creditdays"
                          options={dropdownOptions}
                          className="basic-multi-select"
                          value={selectedCreditDays}
                          onChange={handleCreditDaysChange}
                          styles={style}
                          placeholder="Credit Days"
                          theme={(theme) => ({
                            ...theme,
                            colors: { ...theme.colors, neutral80: "#000000" },
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-4 col-xs-12 mb-2">
                      <div className="mt-32">
                        <button
                          type="button"
                          className="btn request-btn"
                          onClick={handleRequest}
                        >
                          Request
                        </button>
                      </div>
                    </div>{" "}
                  </>
                )}
                {isRequestSubmitted && !isAdditionalRequestShown && (
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                    <div className="text-center">
                      <p onClick={handleShowAdditionalRequest}>
                        Credit request submitted, currently processing
                      </p>
                    </div>
                  </div>
                )}
              </div>
              {isRequestSubmitted && isAdditionalRequestShown && (
                <>
                  <div className="row">
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-2">
                      <div>
                        <label>Available Open Credit </label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter"
                        ></input>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-2">
                      <div>
                        <label>Available LC Credit </label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter"
                        ></input>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-2">
                      <div>
                        <label>Previous Approved Open Credit </label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter"
                        ></input>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-2">
                      <div>
                        <label>Request Additional Open Credit </label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter"
                        ></input>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-2">
                      <div>
                        <label>Supporting File </label>
                        {/* upload */}
                        <div id="file-upload-form" className="upload-btn">
                          <input
                            id="file-upload-attachment-document"
                            type="file"
                            name="commercialRegistration"
                            accept=".pdf"
                          />
                          <label
                            for="file-upload-attachment-document"
                            id="file-drag"
                          >
                            <p>Supporting File</p>
                            <span class="material-icons-outlined">
                              file_upload
                            </span>
                          </label>
                          <label className="d-none">
                            <p>fileName</p>
                            <i className="fas fa-times"></i>
                          </label>
                        </div>
                        <div className="d-none">
                          <div className="uploaded-file-name">
                            <label>
                              <div className="upload-caption">
                                <i className="fas fa-paperclip mr-3"></i>
                                Attach File
                              </div>
                            </label>
                          </div>
                          <form id="file-upload-form" className="upload-btn">
                            <input
                              id="file-upload-attachment-document"
                              type="file"
                              name="commercialRegistration"
                              accept=".pdf"
                            />
                            <label
                              for="file-upload-attachment-document"
                              id="file-drag"
                            >
                              <span class="material-icons-outlined">
                                file_upload
                              </span>
                            </label>
                          </form>
                          <button className="btn delete-icon-btn" type="button">
                            <i className="far fa-trash-alt"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                      <div className="text-right mt-3">
                        <button
                          type="button"
                          className="btn cancel-btn mr-2"
                          onClick={handleCancel}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn request-btn"
                          data-toggle="modal"
                          data-target="#creditLimitRequestModal"
                          disabled
                        >
                          Request
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditLimitApproval;
